//EXPOSED
export const TASK_TYPE = {
  INIT_WHITEBOARD: "INIT_WHITEBOARD",
  CHOOSE_MODE_TYPE: "CHOOSE_MODE_TYPE",
  CHANGE_PENCIL_MODE_COLOR: "CHANGE_PENCIL_MODE_COLOR",
  CHANGE_PAGE_NUMBER: "CHANGE_PAGE_NUMBER",
  PERFORM_UNDO: "PERFORM_UNDO",
  CLEAR_ALL: "CLEAR_ALL"
};

export const ACTION_TYPE = {
  UPDATE_MOUSE_POSITION: "UPDATE_MOUSE_POSITION",
  UPDATE_MOUSE_DOWN: "UPDATE_MOUSE_DOWN",
  ADD_MODE: "ADD_MODE",
  INIT_CONFIG: "INIT_CONFIG",
  SYNC_WITH_SERVER: "SYNC_WITH_SERVER"
};
